<template>
  <div class="wrp">
    <div class="swiper-wrp">
      <van-swipe v-if="!loading" :autoplay="3000" style="height: 100%" :initial-swipe="1" indicator-color="white">
        <van-swipe-item v-for="(img, index) in swiperList" :key="index">
          <img :src="img" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="select">
      <div v-for="item in selectBtnList" :key="item.type" class="select-btn" @click="selectVisibleHandle(item.type)">
        <p>{{item.title}}</p>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <div class="invoice-list">
      <van-list
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-swipe-cell
          style="border-bottom:1px solid rgba(246,246,246,1)"
          v-for="item in invoiceList"
          :key="item.id"
        >
          <template slot="left">
            <p @click="vatCheck(item)" v-if="!item.checkFlag && (item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')" style="background: #07c160;min-width: 60px; float: right" class="operation-btn">查验</p>
            <!-- <p v-if="item.invoiceType === '3'" style="background: #1989fa;min-width: 85px; float: right" class="operation-btn">发送邮箱</p> -->
          </template>
          <div class="item" @click="getDetail(item)">
            <div class="item-title-wrp">
              <div class="item-title-info">
                <my-radio :disable="item.commitFlag === 1" :checked="item.checked" @change="selectChange(item)" />
                <p v-show="item.place">
                  地点：{{item.place}}
                </p>
                <p class="sellerName" v-show="item.sellerName">
                  销方：{{item.sellerName}}
                </p>
                <p class="sellerName" v-show="item.nameOfTheSeller">
                  销方：{{item.nameOfTheSeller}}
                </p>
                <p v-show="item.passengerName || item.stationGetOn">
                  <span v-show="item.passengerName">姓名：{{item.passengerName}}</span>
                  <span style="margin-left: 15px" v-show="item.stationGetOn">{{item.stationGetOn}}—{{item.stationGetOff}}</span>
                </p>
              </div>
              <span class="item-title-warning" v-if="item.ext5 == 1">抬头异常</span>
              <p class="item-title-amount">￥{{item.amountWithTax || (item.ocrAmountWithTax ? item.ocrAmountWithTax : item.ocrTotalAmountOfTaxes)}}</p>
            </div>
            <div class="item-info-wrp">
              <div class="item-info">
                <p class="item-invoice-type">
                  <i v-show="item.invoiceType === '01'" class="basicmobilefont">&#xe634;</i>
                  <span v-show="item.invoiceType === '01'">增值税专用发票</span>
                  <i v-show="item.invoiceType === '04'"  class="basicmobilefont">&#xe633;</i>
                  <span v-show="item.invoiceType === '04'" >增值税普通发票</span>
                  <i v-show="item.invoiceType === '10'" class="basicmobilefont">&#xe642;</i>
                  <span v-show="item.invoiceType === '10'">增值税电子发票</span>
                  <i v-show="item.invoiceType === '11'" class="basicmobilefont">&#xe6ba;</i>
                  <span v-show="item.invoiceType === '11'" >增值税卷式发票</span>
                  <i v-show="item.invoiceType === '201'" class="basicmobilefont">&#xe6b9;</i>
                  <span v-show="item.invoiceType === '201'">火车票</span>
                  <i v-show="item.invoiceType === '202'" class="basicmobilefont">&#xe6b8;</i>
                  <span v-show="item.invoiceType === '202'">飞机客票行程单</span>
                  <i v-show="item.invoiceType === '207'" class="basicmobilefont">&#xe6bc;</i>
                  <span v-show="item.invoiceType === '207'">出租车票</span>
                  <i v-show="item.invoiceType === '200'" class="basicmobilefont">&#xe6bb;</i>
                  <span v-show="item.invoiceType === '200'">定额发票</span>
                </p>
                <p>{{item.drewDate}}</p>
              </div>
              <div class="item-info-auth">
                <span v-if="item.checkFlag == 0 && (item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')" style="color:#FF0000">验真失败</span>
                <span v-if="item.checkFlag == 1" style="color:#2196F3">验真成功</span>
                <span v-if="!item.checkFlag && !(item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')" style="color:#999999">未验真</span>
              </div>
            </div>
          </div>
          <template slot="right">
            <p v-if="!item.commitFlag" @click="delInvoice(item)" style="background: #ee0a24;min-width: 60px" class="operation-btn">删除</p>
          </template>
        </van-swipe-cell>
      </van-list>
    </div>
    <div v-if="totalCount" class="bottom-total">
      <div style="display: flex; justify-content: space-around;align-items: center; width: 52px">
        <my-radio :checked="selectNum === totalCount" @change="allSelect" />
        <span>全选</span>
      </div>
      <p>已选择<span style="margin:0 2px">{{selectNum}}</span>条，合计<span style="margin:0 2px">{{totalMoney}}</span>元</p>
      <van-button @click="submit" v-show="selectNum > 0" type="info">提交</van-button>
      <van-button v-show="selectNum === 0" type="info" color="#BDBDBD">提交</van-button>
    </div>
    <Footer />
    <popup-picker
      :columns="invoiceTypeList"
      :visible="selectSheetVisible.invoiceTypeVisible"
      @cancel="selectSheetVisible.invoiceTypeVisible = false"
      @confirm="onConfirm"
      type="invoiceType"
    />
    <popup-picker
      :columns="invoiceStatusList"
      :visible="selectSheetVisible.statusVisible"
      @cancel="selectSheetVisible.statusVisible = false"
      @confirm="onConfirm"
      type="status"
    />
    <popup-picker
      :columns="invoiceTimeList"
      :visible="selectSheetVisible.dateVisible"
      @cancel="selectSheetVisible.dateVisible = false"
      @confirm="onConfirm"
      type="date"
    />
    <popup-picker
      :columns="moreList"
      :visible="selectSheetVisible.moreVisible"
      @cancel="selectSheetVisible.moreVisible = false"
      @confirm="onConfirm"
      type="more"
    />
    <MyActionSheet
      :columns="companyNameList"
      :visible="selectSheetVisible.companyListVisible"
      @cancel="selectSheetVisible.companyListVisible = false"
      @confirm="onConfirm"
      type="companyList"
    />
    <van-popup v-model="submitSuccessVisible">
      <div class="submit-success">
        <i class="basicmobilefont">&#xe6a8;</i>
        <p>已提交</p>
      </div>
    </van-popup>
  </div>
</template>

<script>

import {
  Toast,
  List,
  Swipe,
  SwipeItem,
  Button,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  Icon,
  ActionSheet,
  SwipeCell,
  Divider,
  Dialog,
  Notify
} from 'vant'
import PopupPicker from '@components/OfficialAccount/PopupPicker'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'
import Radio from '@components/Radio'
import Footer from '@components/OfficialAccount/Footer.vue'
import { ConvertNumber, deepCopy } from '@utils/basicUtil'
import moment from 'moment'
import { officialAccountRequest } from '@services'

export default {
  props: ['loading'],
  data: () => ({
    swiperList: [
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner1.png',
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner2.png',
      'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner3.png'
    ],
    query: {
      asc: '',
      desc: 'createTime',
      size: 25,
      current: 0,
      invoiceType: '',
      commitFlag: '',
      gathererId: ''
    },
    totalMoney: 0,
    totalCount: 0,
    invoiceList: [],
    selectNum: 0,
    showSelect: false,
    isLoading: true,
    finished: false,
    invoiceTypeList: ['全部', '专票', '普票', '电票', '卷票', '火车票', '飞机票', '出租车票', '定额发票'],
    invoiceStatusList: ['全部', '未提交', '已提交'],
    invoiceTimeList: ['录入日期降序', '录入日期升序', '开票日期降序', '开票日期升序'],
    moreList: ['重新查验', '发送至邮箱'],
    companyList: [
    ],
    companyNameList: [],
    dic: {
      '01': '增值税专用发票',
      '02': '货运运输业增值税专用发票',
      '03': '机动车销售统一发票',
      '04': '增值税普通发票',
      '10': '增值税电子普通发票',
      '11': '增值税卷式发票',
      '205': '通行费发票',
      '99': '发票类型有误',
      '': '发票类型有误'
    },
    selectBtnList: [
      {
        title: '票据类型',
        type: 'invoiceType'
      },
      {
        title: '全部状态',
        type: 'status'
      },
      {
        title: '日期',
        type: 'date'
      }
    ],
    selectSheetVisible: {
      invoiceTypeVisible: false,
      statusVisible: false,
      dateVisible: false,
      moreVisible: false,
      companyListVisible: false
    },
    submitSuccessVisible: false,
    officialAccountId: '',
    nonVatList: [],
    vatList: []
  }),
  computed: {
    userInfo: (vm) => {
      return vm.$store.state.officialAccount.userInfo
    }
  },
  watch: {
    userInfo () {
      if (this.userInfo.id && this.query.current === 0) {
        this.init()
        this.getInvoiceList()
        this.getCompanyList()
      }
    }
  },
  mounted () {
    this.initQuery()
    if (this.userInfo.id && this.query.current === 0) {
      this.init()
      this.getInvoiceList()
      this.getCompanyList()
    }
  },
  methods: {
    init () {
      this.query.gathererId = this.userInfo.id
    },
    initQuery () {
      this.finished = false
      this.query.current = 0
    },
    async getCompanyList () {
      const data = await officialAccountRequest.weChat.listAccountbyMobile({ mobile: this.userInfo.mobile })

      if (data.success) {
        this.companyList = data.result
        let companyNameList = []
        this.companyList.forEach(item => {
          companyNameList.push({ name: item.companyName, id: item.id })
        })
        this.$store.commit('officialAccount/changeCompanyList', data.result)
        this.$store.commit('officialAccount/changeCompanyNameList', companyNameList)
        this.companyNameList = companyNameList
      }
    },
    async getInvoiceList () {
      if (this.finished) return

      this.query.current += 1
      this.isLoading = true
      const data = await officialAccountRequest.weChat.getInvoiceList(this.query)
      if (data.success) {
        let arr = deepCopy(data.result.records || [])
        arr.forEach(item => {
          item.checked = false
          if (item.drewDate) {
            item.drewDate = moment(item.drewDate).format('YYYY-MM-DD')
          } else {
            item.drewDate = moment(item.dateOfTicketOpening).format('YYYY-MM-DD')
          }
        })
        this.invoiceList = [...this.invoiceList, ...arr]
        this.totalCount = 0
        this.totalMoney = 0
        this.selectNum = 0
        this.invoiceList.forEach(item => {
          if (!item.commitFlag) {
            this.totalCount++
          }
        })

        if (this.query.current >= Number(data.result.pages) || this.invoiceList.length < 25) {
          this.finished = true
        }
      }
      this.isLoading = false
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    async onLoad () {
      await this.getInvoiceList()
    },
    selectChange (data) {
      this.invoiceList.forEach(item => {
        if (item.id === data.id) {
          item.checked = !item.checked
        }
      })
      this.selectMoney()
    },
    selectMoney () {
      let selectNum = 0
      let totalMoney = 0
      this.invoiceList.forEach(item => {
        if (item.checked) {
          totalMoney += Number(item.amountWithTax || (item.ocrAmountWithTax ? item.ocrAmountWithTax : item.ocrTotalAmountOfTaxes))
          selectNum++
        }
      })
      this.totalMoney = this.convertNumber(totalMoney)
      this.selectNum = selectNum
    },
    allSelect () {
      if (this.totalCount === this.selectNum) {
        this.invoiceList.forEach(item => {
          item.checked = false
        })
        this.totalMoney = 0
        this.selectNum = 0
      } else {
        this.invoiceList.forEach(item => {
          if (!item.commitFlag) {
            item.checked = true
          }
        })
        this.selectMoney()
      }
    },
    async vatCheck (item) {
      Toast.loading({
        message: '发票查验中...',
        forbidClick: true,
        duration: 0
      })
      const data = await officialAccountRequest.weChat.vatCheck({ id: item.id })

      if (data.success) {
        Notify({ type: 'success', message: '查验完毕' })
        this.initQuery()
        this.invoiceList = []
        this.getInvoiceList()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      Toast.clear({
        clearAll: true
      })
    },
    getDetail (data) {
      let type = 0
      switch (data.invoiceType) {
        case '01':
          type = 1
          break
        case '04':
          type = 1
          break
        case '10':
          type = 1
          break
        case '11':
          type = 1
          break
        case '200':
          type = 0
          break
        case '201':
          type = 0
          break
        case '202':
          type = 0
          break
        case '207':
          type = 0
          break
        default:
          break
      }
      this.$router.push(`/official-account/invoice-info?id=${data.id}&type=${type}`)
    },
    submit () {
      let nonVatList = []
      let vatList = []
      this.invoiceList.forEach(item => {
        if (!item.commitFlag) {
          if (item.checked) {
            switch (item.invoiceType) {
              case '01':
                vatList.push(item)
                break
              case '04':
                vatList.push(item)
                break
              case '10':
                vatList.push(item)
                break
              case '11':
                vatList.push(item)
                break
              case '200':
                nonVatList.push(item)
                break
              case '201':
                nonVatList.push(item)
                break
              case '202':
                nonVatList.push(item)
                break
              case '207':
                nonVatList.push(item)
                break
              default:
                break
            }
          }
        }
      })

      this.nonVatList = nonVatList
      this.vatList = vatList

      if (this.companyList.length > 1) {
        this.selectVisibleHandle('companyList')
      } else {
        this.officialAccountId = this.companyList[0].id
        this.commit()
      }
    },
    async commit () {
      Toast.loading({
        message: '发票提交中...',
        forbidClick: true,
        duration: 0
      })
      let nonVatCommitList = []
      this.nonVatList.forEach(item => {
        nonVatCommitList.push(this.nonVatCommit(item))
      })
      let vatCommitList = []
      this.vatList.forEach(item => {
        vatCommitList.push(this.vatCommit(item))
      })
      let progressNonVat = new Promise((resolve, reject) => {
        Promise.all(nonVatCommitList).then(() => {
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
      let progressVat = new Promise((resolve, reject) => {
        Promise.all(vatCommitList).then(() => {
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
      Promise.all([progressNonVat, progressVat]).then(() => {
        this.initQuery()
        this.invoiceList = []
        this.getInvoiceList()
        Toast.clear({
          clearAll: true
        })
        Notify({ type: 'success', message: '提交完成' })
      }).catch((e) => {
        Notify({ type: 'danger', message: e })
        this.initQuery()
        this.invoiceList = []
        this.getInvoiceList()
        Toast.clear({
          clearAll: true
        })
      })
    },
    nonVatCommit (item) {
      return new Promise(async (resolve, reject) => {
        const data = await officialAccountRequest.weChat.nonVatCommit({ officialAccountId: this.officialAccountId, nonVatTicketId: item.id })
        if (data.success) {
          resolve()
        } else {
          reject(data.message)
        }
      })
    },
    vatCommit (item) {
      return new Promise(async (resolve, reject) => {
        const data = await officialAccountRequest.weChat.vatCommit({ officialAccountId: this.officialAccountId, vatTicketId: item.id })
        if (data.success) {
          resolve()
        } else {
          reject(data.message)
        }
      })
    },
    delInvoice (data) {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该发票数据'
      }).then(() => {
        switch (data.invoiceType) {
          case '01':
            this.vatDel(data)
            break
          case '04':
            this.vatDel(data)
            break
          case '10':
            this.vatDel(data)
            break
          case '11':
            this.vatDel(data)
            break
          case '200':
            this.nonVatDel(data)
            break
          case '201':
            this.nonVatDel(data)
            break
          case '202':
            this.nonVatDel(data)
            break
          case '207':
            this.nonVatDel(data)
            break
          default:
            break
        }
      })
    },
    async nonVatDel (item) {
      const data = await officialAccountRequest.weChat.nonVatDel({}, { id: item.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.initQuery()
        this.invoiceList = []
        this.getInvoiceList()
      } else {
        Notify({ type: 'success', message: data.message })
      }
    },
    async vatDel (item) {
      const data = await officialAccountRequest.weChat.vatDel({}, { id: item.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.initQuery()
        this.invoiceList = []
        this.getInvoiceList()
      } else {
        Notify({ type: 'success', message: data.message })
      }
    },
    selectVisibleHandle (type) {
      switch (type) {
        case 'invoiceType':
          this.selectSheetVisible.invoiceTypeVisible = true
          break
        case 'status':
          this.selectSheetVisible.statusVisible = true
          break
        case 'date':
          this.selectSheetVisible.dateVisible = true
          break
        case 'companyList':
          this.selectSheetVisible.companyListVisible = true
          break
        default:
          break
      }
    },
    onConfirm (data) {
      switch (data.type) {
        case 'invoiceType':
          this.initQuery()
          this.selectSheetVisible.invoiceTypeVisible = false
          this.queryInvoiceTypeChange(data)
          this.invoiceList = []
          this.getInvoiceList()
          break
        case 'status':
          this.initQuery()
          this.selectSheetVisible.statusVisible = false
          this.queryStatusChange(data)
          this.invoiceList = []
          this.getInvoiceList()
          break
        case 'date':
          this.initQuery()
          this.selectSheetVisible.dateVisible = false
          this.queryDateChange(data)
          this.invoiceList = []
          this.getInvoiceList()
          break
        case 'companyList':
          this.selectSheetVisible.companyListVisible = false
          this.officialAccountId = data.value.id
          setTimeout(() => {
            this.commit()
          }, 200)
          break
        default:
          break
      }
    },
    queryDateChange (data) {
      switch (data.value) {
        case '录入日期降序':
          this.query.desc = 'createTime'
          this.query.asc = ''
          break
        case '录入日期升序':
          this.query.asc = 'createTime'
          this.query.desc = ''
          break
        case '开票日期降序':
          this.query.desc = 'drewDate'
          this.query.asc = ''
          break
        case '开票日期升序':
          this.query.asc = 'drewDate'
          this.query.desc = ''
          break
        default:
          this.query.desc = 'createTime'
          this.query.asc = ''
          break
      }
    },
    queryStatusChange (data) {
      switch (data.value) {
        case '全部':
          this.query.commitFlag = ''
          break
        case '未提交':
          this.query.commitFlag = 0
          break
        case '已提交':
          this.query.commitFlag = 1
          break
        default:
          this.query.commitFlag = ''
          break
      }
    },
    queryInvoiceTypeChange (data) {
      switch (data.value) {
        case '全部':
          this.query.invoiceType = ''
          break
        case '专票':
          this.query.invoiceType = '01'
          break
        case '普票':
          this.query.invoiceType = '04'
          break
        case '电票':
          this.query.invoiceType = '10'
          break
        case '卷票':
          this.query.invoiceType = '11'
          break
        case '火车票':
          this.query.invoiceType = '201'
          break
        case '飞机票':
          this.query.invoiceType = '202'
          break
        case '出租车票':
          this.query.invoiceType = '207'
          break
        case '定额发票':
          this.query.invoiceType = '200'
          break
        default:
          this.query.invoiceType = ''
          break
      }
    },
    commitCompanyChange (data) {
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].companyName === data.value) {
          return this.companyList[i].id
        }
      }
    }
  },
  components: {
    [Toast.name]: Toast,
    [List.name]: List,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [SwipeCell.name]: SwipeCell,
    [Divider.name]: Divider,
    'popup-picker': PopupPicker,
    'my-radio': Radio,
    Footer,
    MyActionSheet
  }
}
</script>

<style lang="less" scoped>
  .wrp {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    .submitCode {
      z-index: 999;
      width: 130px;
      height: 75px;
      text-align: center;
      position: fixed;
      right: 5%;
      bottom: 15%;
      .submit-btn {
        width: 100%;
        height: 100%;
        background-color: rgba(22,155,213);
        color: #fff;
        font-size: 30px;
        border-radius: 10%;
      }
    }
    .select-total {
      z-index: 2000;
      width: 100%;
      background: #fff;
      border: 1px solid #000;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      font-size: 28px;
      position: fixed;
      bottom: 20%;
    }
    .swiper-wrp {
      height: 260px;
      width: 100%;
      overflow: hidden;
      img {
        height: auto;
        width: 100%;
      }
    }
    .select {
      height: 100px;
      width: 100%;
      overflow: hidden;
      background: #fff;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 28px;
      font-family: 'PingFang SC';
      font-weight: 400;
      color: rgba(153,153,153,1);
      .select-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        color: #999999
      }
    }
    .van-dropdown-menu {
      height: 100px !important;
    }
    .operation-btn {
      height: 100%;
      color: #fff;
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 60px;
    }
    .sellerName {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space:nowrap;
      width: 350px;
    }
    .invoice-list {
      width: 100%;
      // height: calc(100% - 260px);
      height: calc(100% - 580px);
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      margin-top: 20px;
      padding-bottom: 300px;
      .item {
        background: #fff;
        padding: 30px 30px;
        transition: all .5s;
        overflow: hidden;
        .item-title-wrp {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item-title-info {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 26px;
            font-family: 'PingFang SC';
            font-weight: 500;
            color: rgba(51,51,51,1);
            p {
              margin-left: 22px
            }
          }
          .item-title-warning{
            font-size: 24px;
            font-family: 'PingFang SC';
            font-weight: bold;
            color: #f00;
          }
          .item-title-amount {
            font-size: 28px;
            font-family: 'PingFang SC';
            font-weight: bold;
            color: rgba(51,51,51,1)
          }
        }
        .item-info-wrp {
          margin-left: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 30px;
          .item-info {
            font-size: 24px;
            font-family: 'PingFang SC';
            font-weight: 400;
            color: rgba(102,102,102,1);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .item-invoice-type {
              margin-right: 70px;
            }
          }
          .item-info-auth {
            font-size: 24px;
            font-family: 'PingFang SC';
            font-weight: 400;
          }
        }
      }
      .shrink {
        height: 140px;
      }
      .detail {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255,255,255,1);
        padding: 30px 30px 30px 30px;
        // margin-top: 20px;
        .invoice-info {
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: 500;
          .buyer {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .invoicetype-icon {
              font-size: 28px;
            }
            .select-font {
              width: 5%;
              color: rgba(89, 89, 89, 1);
              font-size: 35px;
            }
            .select-font-active {
              width: 5%;
              color: #4573de;
              font-size: 35px;
            }
          }
          .money {
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: bold;
            color: rgba(51,51,51,1);
          }
        }
        .invoice-detail {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
          .invoice-detail-content {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(153,153,153,1);
          }
        }
      }
    }
  }
  .bottom-total {
    background: #fff;
    position: absolute;
    bottom: 116px;
    left: 0;
    width: 100%;
    height: 100px;
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 999;
    box-shadow:0px -1px 27px 0px rgba(153,153,153,0.08);
    opacity: 0.95;
    font-size:24px;
    font-family: 'PingFang SC';
    font-weight: 400;
    color:rgba(153,153,153,1);
    p {
      font-size: 24px;
      letter-spacing: 2px;
      span {
        color: rgba(33,150,243,1)
      }
    }
  }
  .submit-success {
    width: 340px;
    height: 227px;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i {
      font-size: 70px;
      color: #2196F3;
      margin-bottom: 15px;
    }
    p {
      color: rgba(51,51,51,1);
      font-size: 35px;
    }
  }
</style>
